import { useWhatsNewStore } from '../stores/whatsNewStore'

import { registerBootstrapHydrator } from '@/features/account'

export function registerWhatsNewHydrator(): void {
  registerBootstrapHydrator('account_core', {
    hydrate: () => void useWhatsNewStore().loadContent(),
    reset: () => useWhatsNewStore().resetContent(),
  })
}
